/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Open_New_WindowInputs */



/**
* | output |
* | --- |
* | "Open in new window" |
*
* @param {Artifact_Open_New_WindowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_open_new_window = /** @type {((inputs?: Artifact_Open_New_WindowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Open_New_WindowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In neuem Fenster öffnen")
	return /** @type {LocalizedString} */ ("Open in new window")
});